import { Component, Input } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { User } from 'src/app/@shared/models/user/user.model';

@Component({
	selector: 'app-avatar',
	imports: [
		AvatarModule
	],
	templateUrl: './avatar.component.html',
	styleUrl: './avatar.component.scss'
})
export class AvatarComponent {

	@Input()
	public label: string | undefined = undefined;
	@Input()
	public size: 'normal' | 'large' | 'xlarge' | undefined;
	@Input()
	public user: User | undefined = undefined;

	public get displayedLabel(): string | undefined{
		if (!!this.user?.avatar) {
			return undefined;
		} else {
			return this.user?.avatarLabel || this.label;
		}
	}

}
